import { ScriptService } from './../../../../services/cms/script.service';
//Angular
import { Component, OnInit, ViewContainerRef, Compiler, Inject, Renderer } from "@angular/core";
//Services
import { ClientAreaService } from "./../../../../services/settings/client-area.service";
import { LanguageService } from "./../../../../services/cms/language.service";
import { ComponentHelperService } from "./../../../../services/core/component-helper.service";
import { AuthService } from "./../../../../services/core/auth.service";
import { RoutesService } from "./../../../../services/core/routes.service";
import { SeoService } from "./../../../../services/core/seo.service";
import { MessagesService } from "../../../../services/core/messages.service";
import { CookieService } from "../../../../services/core/cookie/cookie.service";
import { BreadcrumbsService } from '../../../../services/cms/breadcrumbs.service';

//Models
import { ClientAreaDetails } from "./../../../../models/settings/client-area";
import { Router } from "@angular/router";
import { Breadcrumbs } from '../../../../models/cms/breadcrumbs';

import { Subscription } from 'rxjs/Subscription';
import { DOCUMENT } from "@angular/platform-browser";
import { SeoViewModel } from '../../../../models/core/seo';

@Component({
    template: ""
})

export class ClientAreaHomeComponent implements OnInit {
    constructor
        (
            private _compiler: Compiler,
            private componentHelper: ComponentHelperService,
            private _elementRef: ViewContainerRef,
            private clientAreaService: ClientAreaService,
            private router: Router,
            @Inject('CookieService') private cookie: CookieService,
            private authService: AuthService,
            @Inject('isBrowser') private isBrowser: boolean,
            private seo: SeoService,
            private renderer: Renderer,
            @Inject(DOCUMENT) private document: any
        ) { }

    subManager = new Subscription();


    ngOnInit() {
        if (!this.authService.GetData().isAuthenticated) {
            this.router.navigate([""]);
        }

        let ClientAreaHomeTemplate: any;

        let userId = this.authService.GetUserId();

        let clientDetailsSub = this.clientAreaService.getDetailsClientArea(userId).subscribe(result => {


            ClientAreaHomeTemplate = result;

            //Creating subcomponent whith the selected template to inject
            let subComponent = this.createSubComponent(ClientAreaHomeTemplate);

            //injecting created component (OK)
            this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);

        })

        this.subManager.add(clientDetailsSub);
    }

    ngOnDestroy() {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    }

    private createSubComponent(ClientAreaHomeTemplate: any) {
        @Component({
            template: ClientAreaHomeTemplate.TemplateHtml
        })

        class ChildComponent implements OnInit {
            constructor
                (
                    private languageService: LanguageService,
                    private authService: AuthService,
                    private routesService: RoutesService,
                    private messagesService: MessagesService,
                    @Inject('isBrowser') private isBrowser: boolean,
                    private seoService: SeoService,
                    private breadcrumbsService: BreadcrumbsService,
                    private scriptService: ScriptService
                ) { }

            clientArea: ClientAreaDetails = new ClientAreaDetails();
            lang: string = this.languageService.getLongLang();

            private messagesList: any[] = [];
            private numberOfMessages: number = 0;
            private bodyMod: any[] = [];
            private lastOrderDetailsPage: string = "";
            private lastOrderId: string;
            private userName: string = "";
            private pageIsInit: boolean = false;

            //checking if invoices module is active
            private isActiveInvoicesModule: boolean = ClientAreaHomeTemplate.isActiveInvoicesModule;

            private breadcrumbs: Breadcrumbs[] = ClientAreaHomeTemplate.BreadcrumbsInfo;
            //Routes for menu-tabs
            private areaClientiHome: string[] = this.routesService.getRoutePath('AREA CLIENTI - STATISTICHE');
            private areaClientiOrdini: string[] = this.routesService.getRoutePath('AREA CLIENTI - LISTA ORDINI');
            private areaChangeProfile: string[] = this.routesService.getRoutePath('AREA CLIENTI - DATI UTENTE - CAMBIO DATI PERSONALI');
            private areaClientiInvoices: string[] = this.routesService.getRoutePath('AREA CLIENTI - INVOICES');

            subManager = new Subscription();

            ngOnInit() {
                setTimeout(x => this.breadcrumbsService.setBreadcrumbs(this.breadcrumbs), 1);
                this.userName = this.authService.GetData().username;
                this.clientArea = ClientAreaHomeTemplate.ClientAreaDetails;
                this.messagesList = this.clientArea.OrderNoteList;
                this.numberOfMessages = this.clientArea.NewNoteOrdersCount;

                //getting of the link for details page of latest order
                this.lastOrderId = String(this.clientArea["LastOrderId"]);
                let url = this.routesService.getRoutePath("AREA CLIENTI - ORDINE")[0];
                this.lastOrderDetailsPage = url.replace(':id', this.lastOrderId);
            }

            ngAfterViewChecked() {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }

                //hiding of loading panel after we get all data we need
                this.routesService.hidePageLoader();

                this.pageIsInit = true;
            }

            showModal() {
                let userId = this.authService.GetUserId();

                let params = {
                    CustomerId: userId,
                    OrderId: "0",
                    Lang: this.lang
                };

                let setMessSub = this.messagesService.setMessagesAsRead(params)
                    .subscribe(result => { })

                this.subManager.add(setMessSub);

                $("#messagesModal").modal("show");

                this.bodyMod = [];
            }

            hideModal() {
                $('#basic').modal('hide');
                this.numberOfMessages = 0;
            }

            messagesDetails(orderId) {
                let id = orderId;
                let orderDetailsPage = this.routesService.getRoutePath('AREA CLIENTI - ORDINE_PAGE_FROM')[0];

                orderDetailsPage = orderDetailsPage.replace(':id', id.toString()).replace(':pagefrom', "section_comunicazioni");

                return orderDetailsPage;
            }

            ngOnDestroy() {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            }
        }

        return ChildComponent;
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/settings/client-area/sys/client-area-home.component.ts